import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";

import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import Titulo from "../../../generico/TituloPagina";
import DatosSocio from "../../../generico/DatosSocio"

import Authservice from "../../../../services/login/auth.service";
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import TransferQrService from "../../../../services/transferencias/TransferQrService";
import PopupMostrarQr from "./PopupMostrarQr";
import Moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faQrcode} from "@fortawesome/free-solid-svg-icons";

export default class TransferenciaQrPedir extends Component {
  TIPO_CUENTA = "D";
  COD_PAGO_CUENTA_AHORRO = 'CCAHOD';
  COD_PARTICIPANTE = '1607';
  fechaVencimiento = Moment(new Date()).format('DD-MM-YYYY');//(new Date()).toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric'}) 

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getInitialState = () => ({
    cuentasOrigen: [],
    cuentaCredito: "",
    monto: 0,
    cuentaOrigenSelected: [],
    itemSelected: { value: "-1", label: "--Seleccione--" },
    nombreSocio: "",
    cedulaSocio: "",
    imgQr: "",
  });

  componentDidMount() {
    this.getCuentas(this.TIPO_CUENTA);

    let usuario = Authservice.getCurrentUser();

    this.setState({
      nombreSocio: usuario.nombreCompleto,
      cedulaSocio: usuario.cedulaIdentidad
    })
  }

  selectorValue = (dataFromChild, item) => {
    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaCredito: dataFromChild.ahorro,
        itemSelected: item,
      },
    );
  };

  montoValue = (_monto) => {
    this.setState(
      {
        monto: _monto,
      },
    );
  };

  getCuentas(tipo) {
    trackPromise(
      TransferCuentasPropiasService.getCuentas(tipo).then((response) => {
        var cuentas = (response.data.resultadoAH !== null ? response.data.resultadoAH : []);
        this.setState({ cuentasOrigen: cuentas });
      })
    );
  }

  precondGenerar() {
    if (this.state.cuentaCredito === "") {
      Popup.queue(this.notifiPopup("Info", "Debe cargar la cuenta de Crédito"));
      return false;
    }
    if (
      this.state.monto.toString().trim().length === 0 ||
      splitImporte(this.state.monto) === "0"
    ) {
      Popup.queue(this.notifiPopup("Info", "El monto debe ser mayor a 0"));
      return false;
    }
    return true;
  }

  generarQR() {
    let data = {
      canalOrigen: "CU24HS_WEB",
      importe: this.state.monto.toString().replace(/\./g, ""),
      tipoCuentaDestino: this.COD_PAGO_CUENTA_AHORRO,
      codDestinatario: this.COD_PARTICIPANTE,
      numCuentaDestino: this.state.cuentaCredito,
      docDestinatario: this.state.cedulaSocio,
      titularDestinatario: this.state.nombreSocio,
      fechaVencimiento: this.fechaVencimiento,
      usoUnico: true
    }
    trackPromise(
      TransferQrService.generarQr(data).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === "0") {
          this.setState({ imgQr: jData.datos.image });
          this.modalCtrlConfirm.click();
        } else {
          if (jData.mensajeRetorno) {
            Popup.queue(this.notifiPopup("Error", jData.mensajeRetorno));
          }
        }
      })
    );
  }

  render() {

    return (
      <div className="content-wrapper">
        <PopupMostrarQr imgQr={this.state.imgQr} />
        <Titulo texto="Cobrar-Recibir Transferencia por QR" />
        <section className="content">
          <form id="idPrestamoForm">
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <DatosSocio />
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6 col-md-10">
                          <CuentaSocioTransferencia
                            renderMonto="true"
                            selectorValue={this.selectorValue.bind(this)}
                            montoValue={this.montoValue.bind(this)}
                            operacion="CREDITO"
                            tipoCuenta="AHORRO_VISTA"
                            items={this.state.cuentasOrigen}
                            monto={this.state.monto}
                            itemSelected={this.state.itemSelected}
                          />
                        </div>
                      </div>
                     <hr />
                     <div className="container">
                      <div className="row">
                        <div className="col-lg-10 col-md-9">
                        <label className="input-label-bold-obligatorio">
                        (*) Campos Obligatorios
                      </label>
                        </div>
                        <div className="col-lg-2 col-md-3">
                        <button className="btn btn-cu-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          if (this.precondGenerar()) {
                            this.generarQR();
                          }
                        }}>
                       <FontAwesomeIcon icon={faQrcode} /> Generar QR
                      </button>
                     
                        </div>
                      </div>
                      </div>
                    </div>
                
                    <a
                        ref={(a) => (this.modalCtrlConfirm = a)}
                        href="#"
                        hidden
                        id="modal-qr-generado"
                        data-toggle="modal"
                        data-target="#modal-qr-generado"
                      ></a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    );
  }
}
